import { render } from "./NavbarElement.vue?vue&type=template&id=83992ff4"
import script from "./NavbarElement.vue?vue&type=script&lang=js"
export * from "./NavbarElement.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__